import * as React from 'react';
import { Box, IconButton, Link, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import RemoveIcon from '@mui/icons-material/Remove';

interface SiteColumnProps {
  selectedUserId: number | null;
  selectedSiteId: number | null;
  siteIds: number[] | undefined | null;
  getSiteName: (siteId: number) => string;
  onSiteClick: (siteId: number) => void;
  onDeleteSite?: (siteId: number) => void;
}

const SiteColumn: React.FC<SiteColumnProps> = ({
  selectedUserId,
  selectedSiteId,
  siteIds,
  getSiteName,
  onSiteClick,
  onDeleteSite,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Grid size={{ xs: 6 }} sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
      {!selectedUserId ? (
        <Box
          sx={{
            alignItems: 'center',
            ...theme.typography.placeHolderFont
          }}
        >
          {t('users:t.selectUser')}
        </Box>
      ) : (
        siteIds?.map((siteId) => (
          <Box
            key={siteId}
            onClick={() => onSiteClick(siteId)}
            sx={{
              display: 'flex',
              height: '30px',
              minHeight: '30px',
              paddingLeft: '12px',
              paddingRight: '8px',
              alignItems: 'center',
              gap: '8px',
              alignSelf: 'stretch',
              mb: 1,
              ...theme.typography.usersFontTitle,
              cursor: 'pointer',
              borderRadius: '4px',
              transition: 'background-color 0.2s',
              backgroundColor: selectedSiteId === siteId ? 'rgba(0, 128, 0, 0.08)' : 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(0, 128, 0, 0.12)',
              },
            }}
          >
            <Box
              component="span"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flexGrow: 1,
              }}
            >
              <Link
                component="span"
                underline="hover"
                color="inherit"
                sx={{
                  ...theme.typography.usersFontTitle,
                  textAlign: 'left',
                }}
              >
                {getSiteName(siteId)}
              </Link>
            </Box>
            <IconButton
              aria-label="delete-site"
              size="small"
              onClick={(event) => {
                event.stopPropagation();
                onDeleteSite?.(siteId);
              }}
              sx={{ color: 'grey.500' }}
            >
              <RemoveIcon fontSize="small" />
            </IconButton>
          </Box>
        ))
      )}
    </Grid>
  );
};

export default SiteColumn;
